import { useState } from 'react'
import { TableSortOption } from '../../../enums'
import { SortOrder, RequestSortHandler, SortFn, ColSortingConfigs } from './types'

const useSort = <T>(
  colSortingConfigs?: Array<ColSortingConfigs<keyof T>>
): [
  SortFn<T>,
  SortOrder | undefined,
  keyof T | undefined,
  (requestOrder: SortOrder, requestOrderBy: keyof T) => void
] => {
  const [order, setOrder] = useState<SortOrder | undefined>(
    colSortingConfigs?.find((item) => item.order !== 'NONE')?.order
  )

  const [orderBy, setOrderBy] = useState<keyof T | undefined>(
    colSortingConfigs?.find((item) => item.order !== 'NONE')?.field
  )

  // rerender when header clicked
  const handleRequestSort: RequestSortHandler<T> = (requestOrder, requestOrderBy) => {
    setOrder(requestOrder)
    setOrderBy(requestOrderBy)
  }

  const sort: SortFn<T> = (data, colDefs) => {
    if (!order || !orderBy) return data

    const orderByCol = colDefs.find((def) => def.field === orderBy)
    if (!orderByCol) return data

    const sortedData = [...data].sort(orderByCol.comparator || undefined)
    if (order === TableSortOption.DESCEND) {
      sortedData.reverse()
    }

    return sortedData
  }

  return [sort, order, orderBy, handleRequestSort]
}

export default useSort
